/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const CartSidebarRightIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="CartSidebarRightIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.4"
            d="M9 3V2H2C1.44772 2 1 2.44772 1 3V13C1 13.5523 1.44772 14 2 14H9V13H2V3H9Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 2C14.5523 2 15 2.44772 15 3V13C15 13.5523 14.5523 14 14 14H11C10.4477 14 10 13.5523 10 13V3C10 2.44772 10.4477 2 11 2H14ZM11 3H14V13H11V3Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

CartSidebarRightIcon.tags = ['cart', 'sidebar', 'right', 'window', 'panel'];

CartSidebarRightIcon.category = 'Ecommerce';

CartSidebarRightIcon.iconSize = 16;
